import { render } from "./BlogTwo.vue?vue&type=template&id=ba129092&scoped=true"
import script from "./BlogTwo.vue?vue&type=script&lang=js"
export * from "./BlogTwo.vue?vue&type=script&lang=js"

import "./BlogTwo.vue?vue&type=style&index=0&id=ba129092&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba129092"]])

export default __exports__